import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const circleIconVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type CircleIconProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof circleIconVariants>;

const CircleIcon = React.forwardRef<SVGSVGElement, CircleIconProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          circleIconVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox}
        width={width}
        {...props}
      >
        <path d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM13.53 6.47L13.446 6.397C13.3186 6.30281 13.1646 6.2514 13.0061 6.25014C12.8477 6.24888 12.6929 6.29784 12.564 6.39L12.47 6.47L10 8.939L7.53 6.469L7.446 6.397C7.31857 6.30281 7.16459 6.2514 7.00614 6.25014C6.84768 6.24888 6.6929 6.29784 6.564 6.39L6.47 6.47L6.397 6.554C6.30281 6.68143 6.2514 6.83541 6.25014 6.99386C6.24888 7.15232 6.29784 7.3071 6.39 7.436L6.47 7.53L8.939 10L6.469 12.47L6.397 12.554C6.30281 12.6814 6.2514 12.8354 6.25014 12.9939C6.24888 13.1523 6.29784 13.3071 6.39 13.436L6.47 13.53L6.554 13.603C6.68143 13.6972 6.83541 13.7486 6.99386 13.7499C7.15232 13.7511 7.3071 13.7022 7.436 13.61L7.53 13.53L10 11.061L12.47 13.531L12.554 13.603C12.6814 13.6972 12.8354 13.7486 12.9939 13.7499C13.1523 13.7511 13.3071 13.7022 13.436 13.61L13.53 13.53L13.603 13.446C13.6972 13.3186 13.7486 13.1646 13.7499 13.0061C13.7511 12.8477 13.7022 12.6929 13.61 12.564L13.53 12.47L11.061 10L13.531 7.53L13.603 7.446C13.6972 7.31857 13.7486 7.16459 13.7499 7.00614C13.7511 6.84768 13.7022 6.6929 13.61 6.564L13.53 6.47L13.446 6.397L13.53 6.47V6.47Z" />
      </svg>
    );
  },
);

CircleIcon.displayName = 'CircleIcon';

export { CircleIcon, circleIconVariants };
